import React from 'react';

import { createBrowserRouter } from 'react-router-dom';

import ErrorPage404 from '../pages/404';
import AboutPage from '../pages/about';
import HomePage from '../pages/homepage';
import Layout from '../pages/layout/Layout';
import LegalsPage from '../pages/legals';
import LoginPage from '../pages/login';
import ProjectDetailsPage from '../pages/projectDetails';
import ProjectsPage from '../pages/projects';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorPage404 />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },

      {
        path: 'about',
        element: <AboutPage />,
      },

      {
        path: 'projects',
        element: <ProjectsPage />,
      },

      {
        path: 'projects/:id',
        element: <ProjectDetailsPage />,
      },

      {
        path: 'legals/:type',
        element: <LegalsPage />,
      },

      {
        path: 'login',
        element: <LoginPage />,
      },

      {
        path: '*',
        element: <ErrorPage404 />,
      },
    ],
  },
]);

export default router;